export default "__VITE_ASSET__BKs_wPV___"